// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-login-login',
    // #endregion
    // #region Data
    data: () => ({
        userName: "",
        password: "",
        errorMessage: "",
        isLoading: false
    }),
    // #endregion
    // #region Constructor
    created() {
        this.userName = appHost.login.getUsername() ?? '';
    },
    // #endregion
    // #region Watch
    watch: {
        userName: function (val) {
            this.errorMessage = '';
        },
        password: function (val) {
            this.errorMessage = '';
        }
    },
    // #endregion
    // #region Computed
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isEmpty(this.userName) || utils.isEmpty(this.password);
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async runLogin() {
            // #region Check
            //Reset
            this.errorMessage = "";
            //Check
            if (this.isLoading) {
                return;
            }
            if (utils.isEmpty(this.userName)) {
                return;
            }
            if (utils.isEmpty(this.password)) {
                return;
            }
            // #endregion
            // #region Init
            this.isLoading = true;
            // #endregion
            // #region Run
            try {
                let tResult = await appHost.login.loginByUsername(this.userName, this.password);
                {
                    // #region Meter
                    this.isLoading = false;
                    // #endregion
                    // #region Error
                    if (!tResult.isSucceded) {
                        if (tResult.errorCode === 'account_activate') {
                            let tRequest = {
                                name: "login-activate",
                                params: {
                                    userId: tResult.customData.userId
                                },
                                query: {
                                    returnUrl: this.$route.query?.returnUrl
                                }
                            };
                            this.$router.push(tRequest);
                        }
                        else if (tResult.errorCode === 'account_password_change') {
                            let tRequest = {
                                name: "login-password_change",
                                query: {
                                    userId: utils.encodeBase64(tResult.customData.userId),
                                    userName: utils.encodeBase64(this.userName),
                                    code: tResult.customData.code,
                                    returnUrl: this.$route.query?.returnUrl
                                }
                            };
                            this.$router.push(tRequest);
                        }
                        else if (tResult.errorCode === 'account_mfa') {
                            let tRequest = {
                                name: "login-mfa",
                                query: {
                                    returnUrl: this.$route.query?.returnUrl
                                }
                            };
                            this.$router.push(tRequest);
                        }
                        else {
                            this.errorMessage = tResult.errorMessage;
                        }
                    }
                    // #endregion
                    // #region Default
                    else {
                        if (this.$route.query?.returnUrl || this.$route.query?.ReturnUrl) {
                            //Parse
                            let tUrl = decodeURIComponent((this.$route.query?.returnUrl ?? this.$route.query?.ReturnUrl));
                            //Special
                            window.location.href = tUrl;
                        }
                        else if (tResult.redirectUrl) {
                            this.$router.push(tResult.redirectUrl);
                        }
                        else if (this.$appHost.config.loggedInUrl) {
                            nextTick(() => {
                                this.$router.push(this.$appHost.config.loggedInUrl);
                            });
                        }
                        else {
                            this.$router.push("/");
                        }
                    }
                    // #endregion
                }
            }
            catch (e) {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion                    
            }
            // #endregion
        },
        runOIDC() {
            window.location.href = '/oidc/challenge';
        },
    }
    // #endregion
});
// #endregion
